export class HubspotElement extends HTMLElement {

	private init() {
		const {
			fetched: isFetched,
			formId,
			portalId,
			region
		} = this.dataset;

		if (!isFetched && formId && portalId && this.closest('.popup-host')) {
			if (!this.id) {
				this.id = crypto.randomUUID();
			}

			this.dataset.fetched = Date.now().toString();

			fetch(`https://forms-${region}.hsforms.com/embed/v4/render-definition/ssr/${portalId}/${formId}`)
				.then(response =>
					response.ok
						? response.text()
						: response.text().then(errorText => Promise.reject(errorText))
				)
				.then(formHtml => {
					this.innerHTML = formHtml.replace(/{{hs_form_instance_id_placeholder}}/g, this.id);
						// .replace('setupIslandHydration()', 'window.setupIslandHydration=setupIslandHydration')
					for (const el of this.querySelectorAll('script')) {
						const newEl = document.createElement('script');
						for (const a of el.attributes) {
							newEl.setAttribute(a.name, a.value);
						}
						newEl.textContent = el.textContent;
						el.replaceWith(newEl);
					}
					this.dataset.loaded = Date.now().toString();
				})
				.catch((...errorArgs) => console.error('[hubspot-forms-v4]:', ...errorArgs));
		}
	}

	static get observedAttributes(): string[] {
		return ['data-form-id'];
	}

	public attributeChangedCallback(name: string, oldValue: string, newValue: string): void {
		if (name === 'data-form-id' && newValue !== oldValue) {
			this.dataset.fetched = '';
			this.init();
		}
	}

	public connectedCallback() {
		this.init();
		setTimeout(() => {
			const param = new URLSearchParams(window.parent.location.search).get('formId');
			if (param === this.id) {
				this.closest('.hubspot-container')
					.querySelector<HTMLButtonElement>('button[data-toggle=modal]')
					?.click();
			}
		});
	}
}
